import { kebabCase } from 'lodash';
import { CustomListFieldDefinitionTypeEnum } from '../../../../enum/custom-lists/custom-list-field-definition-type.enum';

export const getCustomListFieldTypeLabel = (type: CustomListFieldDefinitionTypeEnum) => `custom-list.field-type.${kebabCase(type).toLowerCase()}`;